<template>
  <div class="page-column">
    <h2>裁判审核名单</h2>
    <a-table :columns="columns" :data-source="data" :pagination="false" bordered>
      <template slot="name" slot-scope="text">
        <a>{{ text }}</a>
      </template>
      <template slot="title" slot-scope="currentPageData">
        搜索：<a-input-search placeholder="请输入名字或者身份证搜索" style="width: 300px" @search="onSearch" />
        <a-radio-group @change="changeStatus" v-model="valData.status" style="margin-bottom: 16px">
          <a-radio-button :value="-1">
            全部
          </a-radio-button>
          <a-radio-button :value="0">
            未审核
          </a-radio-button>
          <a-radio-button :value="1">
            审核通过
          </a-radio-button>
          <a-radio-button :value="2">
            审核未通过
          </a-radio-button>
        </a-radio-group>
      </template>
      <template slot="image" slot-scope="text, record">
        <img :src="text" style="width: 40px;height: 50px;border-radius: 3px;"/>
      </template>
      <template slot="sex" slot-scope="text, record">
        <a-tag v-if="text === 2" color="pink">女</a-tag>
        <a-tag v-if="text === 1" color="blue">男</a-tag>
      </template>
      <template slot="areaCode" slot-scope="text, record">
        {{ getAddressNameByCode(address, [], text + '',1).join("") }}
      </template>
      <template slot="refereeLevel" slot-scope="text, record">
        <!-- <a-tag color="blue">{{ text }}</a-tag> -->
        <div v-if="record.sportsLevel" style="margin-bottom: 5px;"><a-tag color="blue">竞技{{ record.sportsLevel }}</a-tag></div>
        <div v-if="record.poomsaeLevel"><a-tag color="blue">品势{{ record.poomsaeLevel }}</a-tag></div>
      </template>
      <template slot="validityDate" slot-scope="text, record">
        <template v-if="record.certificate">培训合格证书：<a :href="record.certificate" target="_blank"><img :src="record.certificate" style="width:32px;height:32px;"></a></template>
        <template v-if="record.levelImg">等级证书：<a :href="record.levelImg" target="_blank"><img :src="record.levelImg" style="width:32px;height:32px;"></a></template>
      </template>
      <template slot="status" slot-scope="text, record">
        <a-tag v-if="text === 0">未审核</a-tag>
        <a-tag v-if="text === 1" color="#87d068">通过</a-tag>
        <a-tag v-if="text === 2" color="#f50">不通过【驳回信息：{{ record.msg }}】</a-tag>
      </template>
      <template slot="isSelect" slot-scope="text, record">
        <a-dropdown >
            <a-menu slot="overlay" @click="handleMenuTypeClick($event, record.id)">
              <a-menu-item :key="0">未选调</a-menu-item>
              <a-menu-item :key="1">选调</a-menu-item>
            </a-menu>
            <a-button size="small" v-if="text === 0" >
              未选调<a-icon type="down" />
            </a-button>
            <a-button size="small" v-if="text === 1" type="primary">
              选调
              <a-icon type="down" />
            </a-button>
        </a-dropdown>
      </template>
      <template slot="action" slot-scope="text, record">
        <a-button type="dashed" @click="$refs.editReferee.show(record)">
          编辑
        </a-button>
        <a-popconfirm
          title="确定审查通过吗?"
          @confirm="() => check(record.id, 1)"
        >
          <a-button type="primary" icon="check">通过</a-button>
        </a-popconfirm>
        <a-popover title="不通过，请填写原因" trigger="click">
          <template slot="content">
            <a-input placeholder="请输入不通过的原因" v-model="record.msg"/><br/><br/>
            <a-button type="primary" @click="checkMsg(record, 2)">
              提交
            </a-button>
          </template>
          <a-button type="danger" icon="close">不通过</a-button>
        </a-popover>
      </template>
      
    </a-table>
    <EditReferee ref="editReferee" @ok="findData"/>
  </div>
</template>
<script>
import matchFun from '@comm/utils/matchFun'
import EditReferee from '../match/referee/modal/EditReferee'
import { getAddressNameByCode } from '@comm/utils/addressUtil'
import address from '@comm/utils/address'
export default {
  components: {
    EditReferee
  },
  data() {
    return {
      matchFun,
      address,
      getAddressNameByCode,
      columns: [
        {
          title: '序号',
              dataIndex: 'index',
              key: 'index',
              width: 70,                    
              fixed: 'left',
              customRender: (text,record,index) => `${(index+1)}`, // 关键句
        },
        {
          title: '头像',
          dataIndex: 'image',
          scopedSlots: { customRender: 'image' },
        },
        {
          title: '名称',
          dataIndex: 'name',
        },
        {
          title: '身份证',
          dataIndex: 'card',
        },
        {
          title: '裁判等级',
          dataIndex: 'refereeLevel',
          scopedSlots: { customRender: 'refereeLevel' },
        },
        {
          title: '性别',
          dataIndex: 'sex',
          scopedSlots: { customRender: 'sex' },
        },
        // {
        //   title: '地区',
        //   dataIndex: 'areaCode',
        //   scopedSlots: { customRender: 'areaCode' },
        // },
        {
          title: '衬衫型号',
          dataIndex: 'shirtModel',
        },
        // {
        //   title: '银行卡号',
        //   dataIndex: 'bankCard',
        // },
        // {
        //   title: '开户行',
        //   dataIndex: 'openingBank',
        // },
        {
          title: '联系电话',
          dataIndex: 'mobile',
        },
        // {
        //   title: '紧急联系人',
        //   dataIndex: 'contact',
        // },
        // {
        //   title: '紧急联系人电话',
        //   dataIndex: 'contactMobile',
        // },
        {
          title: '证书',
          dataIndex: 'validityDate',
          scopedSlots: { customRender: 'validityDate' },
        },
        {
          title: '审核状态',
          dataIndex: 'statusCode',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '选调状态',
          dataIndex: 'isSelect',
          scopedSlots: { customRender: 'isSelect' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      data: [],
      current: 1,
      matchId: Number(this.$route.query.matchId),
      valData: {
        matchId: Number(this.$route.query.matchId),
        status: -1,
        keyword: ''
      },
      total: 0
    }
  },
  mounted () {
    document.title = '道吧网 | 组委会 | 裁判管理'
    this.findData()
  },
  methods: {
    findData () {
      this.$api.match.refereeList(this.valData).then(res => {
        if (res.status === 0) {
          this.data = res.data
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('获取列表失败')
      })
    },
    changeStatus (e) {
      console.log(e)
      this.valData.status = e.target.value
      this.findData()
    },
    onSearch (e) {
      console.log(e)
      this.valData.keyword = e
      this.findData()
    },
    check (id, status) {
      this.$api.match.refereeCheckMsg({refereeId: id, matchId: this.matchId, status: status}).then(res => {
        if(res.status === 0){
          this.$message.success(`成功`)
          this.findData()
        }
      }).catch(err => {
          console.log(err )
      })
    },
    checkMsg (record, status) {
      if (!record.msg || record.msg === '') {
        this.$message.error(`请填写不通过的原因`)
        return
      }
      this.$api.match.refereeCheckMsg({refereeId: record.id, matchId: this.matchId, status: status, msg: record.msg}).then(res => {
        if(res.status === 0){
          this.$message.success(`成功`)
          this.findData()
        }
      }).catch(err => {
          console.log(err )
      })
    },
    handleMenuTypeClick (e, refereeId) {
      const that = this
      this.$confirm({
        title: '提示',
        content: `确定修改为该状态吗?`,
        okText: '提交',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          var valData = {
            matchId: that.matchId,
            refereeId: refereeId,
            isSelect: e.key
          }
          that.$api.match.updateRefereeIsSelect(valData).then((res) => {
            if (res.status === 0) {
              that.$message.success(res.msg)
              that.findData()
            } else {
              that.$message.error(res.msg)
            }
          })
        },
        onCancel () {
          console.log('Cancel')
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.page-column {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  padding: 20px;
  .content {
    position: relative;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/organizing/Referee.vue